export type ReverseGeocodeResult = {
  state: string | null;
  district: string | null;
};

// Resolves a rough state/district name for a lat/lng via Nominatim reverse
// geocoding (same OSM service already used elsewhere in this codebase for
// auto-filling state/zipcode from browser geolocation). Used to match the
// user's current location against our partner data's state_name/district_name.
export async function reverseGeocode(lat: number, lng: number): Promise<ReverseGeocodeResult | null> {
  try {
    const res = await fetch(
      `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`,
      { headers: { "Accept-Language": "en" } }
    );
    const data = await res.json();
    const address = data?.address;
    if (!address) return null;

    return {
      state: address.state ?? null,
      district: address.state_district ?? address.county ?? null,
    };
  } catch {
    return null;
  }
}
